import { Injectable } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { MessageNoticeComponent, MessageNoticeConverter } from '../views/message-notice/message-notice.component';
import { PerformerComponent, PerformerConverter } from '../views/performer/performer.component';
import { ExecuteFormsComponent, ExecuteFormsConverter } from '../views/execute-forms/execute-forms.component';
import { ExtendPropertyComponent, ExtendPropertyConverter } from '../views/extend-property/extend-property.component';
import { OrganizationPotentialOwnerComponent, OrganizationPotentialOwnerConverter } from '../views/organization-potential-owner/organization-potential-owner.component';
import { ParticipantComponent, ParticipantConverter } from '../views/participant/participant.component';
import { NotifyActivityPropertyKeys } from '../designer/wf-cell/property-keys/NotifyActivityPropertyKeys';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()
export class NotifyActivityAdapter {
    constructor(
        private uiState: ProcessDesignerUIState,
        private localPipe: WfLocalePipe
    ) {
    }
    setProperty(obj: any) {
        this.uiState.propertyData = obj.propertyData;
        this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
    }

    private setConfig(obj: any[]): ElementPropertyConfig[] {
        const propertyConfig: ElementPropertyConfig[] = [];
        if (obj) {
            obj.forEach((element: ElementPropertyConfig) => {
                this.setEntity(element.properties);
                propertyConfig.push(element);
            });
        }
        return propertyConfig;
    }
    private setEntity(obj: PropertyEntity[]) {
        if (obj && obj.length > 0) {
            obj.forEach((item: PropertyEntity) => {
                switch (item.propertyID) {
                    case NotifyActivityPropertyKeys.Id: // 标识
                        break;
                    case NotifyActivityPropertyKeys.ParticipantSchemes: // 参与者
                        item.editor = ParticipantComponent;
                        item.converter = new ParticipantConverter(this.localPipe);
                        item.editorParams = {
                            nodeType: 'notifyActivity'
                        };
                        break;
                    case NotifyActivityPropertyKeys.wf_ExecuteForms_PC: // 表单定义
                        item.editor = ExecuteFormsComponent;
                        const params = {
                            location: 'notifyActivity',
                            tab: 'web'
                        };
                        item.converter = new ExecuteFormsConverter(params, this.localPipe);
                        item.editorParams = params;
                        break;
                    case NotifyActivityPropertyKeys.wf_ExecuteForms_Mobile: // 表单定义
                        item.editor = ExecuteFormsComponent;
                        const editorParams = {
                            location: 'notifyActivity',
                            tab: 'mobile'
                        };
                        item.converter = new ExecuteFormsConverter(editorParams, this.localPipe);
                        item.editorParams = editorParams;
                        break;
                    case NotifyActivityPropertyKeys.messageNotice: // 消息通知
                        item.editor = MessageNoticeComponent;
                        item.converter = new MessageNoticeConverter(this.localPipe);
                        item.editorParams = {
                            location: 'activity'
                        };
                        break;
                    case NotifyActivityPropertyKeys.NotifyAble: // 允许知会
                        item.editor = OrganizationPotentialOwnerComponent;
                        item.converter = new OrganizationPotentialOwnerConverter(this.localPipe);
                        item.editorParams = {
                            nodeType: 'notifyActivity',
                          };
                        break;
                    default:
                        item.editor = ExtendPropertyComponent;
                        item.converter = new ExtendPropertyConverter(this.localPipe);
                        break;
                }
            });
        }
    }
}
